import { Plugins } from "phaser";

export default class DialogModalPlugin extends Plugins.BasePlugin {
  constructor(pluginManager) {
    super(pluginManager);

    this.borderThickness = 3;
    this.borderColor = 0xF2C763;
    this.borderAlpha = 1;
    this.windowAlpha = 0.8;
    this.windowColor = 0x303030;
    this.windowHeight = 150;
    this.padding = 32;
    this.closeBtnColor = 'darkgoldenrod';
    this.dialogSpeed = 4;
    // used for animating the text
    this.eventCounter = 0;
    // if the dialog window is shown
    this.visible = true;
    // the current text in the window
    this.text;
    // the text that will be displayed in the window
    this.dialog;
    this.graphics;
    this.closeBtn;
    this.scene;
    this.dimensions;
    this.clickEvent;
    this.id = null
    this.dataToSend = null;
  }

  // Gets the width of the game (based on the scene)
  _getGameWidth() {
    return this.scene.sys.game.config.width;
  }
  // Gets the height of the game (based on the scene)
  _getGameHeight() {
    return this.scene.sys.game.config.height;
  }
  // Calculates where to place the dialog window based on the game size
  _calculateWindowDimensions(width, height) {
    let x = this.padding;
    let y = height - this.windowHeight - this.padding;
    let rectWidth = width - (this.padding * 2);
    let rectHeight = this.windowHeight;
    return {
      x,
      y,
      rectWidth,
      rectHeight
    };
  }
  // Creates the inner dialog window (where the text is displayed)
  _createInnerWindow(x, y, rectWidth, rectHeight) {
    this.graphics.fillStyle(this.windowColor, this.windowAlpha);
    this.graphics.fillRect(x + 1, y + 1, rectWidth - 1, rectHeight - 1);
  }
  // Creates the border rectangle of the dialog window
  _createOuterWindow(x, y, rectWidth, rectHeight) {
    this.graphics.lineStyle(this.borderThickness, this.borderColor, this.borderAlpha);
    this.graphics.strokeRect(x, y, rectWidth, rectHeight);
  }
  // Creates the dialog window
  _createWindow(scene, id, padding = null, hideClose = false, data = null) {
    this.scene = scene;
    this.id = id;
    this.dataToSend = data;
    if(padding) {
      this.padding = padding
    }
    let gameHeight = this._getGameHeight();
    let gameWidth = this._getGameWidth();
    let dimensions = this._calculateWindowDimensions(gameWidth, gameHeight);
    this.graphics = scene.add.graphics();
    this._createOuterWindow(dimensions.x, dimensions.y, dimensions.rectWidth, dimensions.rectHeight);
    this._createInnerWindow(dimensions.x, dimensions.y, dimensions.rectWidth, dimensions.rectHeight);
    
    if(!hideClose) {
      this._createCloseModalButton();
      this._createCloseModalButtonBorder();
    }
    this.graphics.setDepth(1).setScrollFactor(0);
    this.visible = true;
  }

  // Creates the close dialog window button
  _createCloseModalButton() {
    let self = this;
    this.closeBtn = this.scene.make.text({
      x: this._getGameWidth() - this.padding - 48,
      y: this._getGameHeight() - (this.padding*2 + 2),
      text: 'SPACE',
      style: {
        font: 'bold 18px CustomFont',
        fill: "#fff",
        stroke: "#000", strokeThickness: 2
      }
    });
    this.closeBtn.setDepth(1).setScrollFactor(0);
    this.closeBtn.setInteractive();
    this.closeBtn.on('pointerover', function () {
      // this.setFill(0x8A2A2B);
    });
    this.closeBtn.on('pointerout', function () {
      this.clearTint();
    });
    this.closeBtn.on('pointerdown', function () {
      self.toggleWindow();
    });

    if (self.timedEvent) self.timedEvent.remove();
    if (self.text) self.text.destroy();
  }

  // Creates the close dialog button border
  _createCloseModalButtonBorder() {
    let x = this._getGameWidth() - this.padding - 50;
    let y = this._getGameHeight() - (this.padding * 2);
    this.graphics.strokeRect(x, y, 40, 20);
    this.graphics.setDepth(1).setScrollFactor(0);
  }

  toggleWindow() {
    this.scene.events.emit('buttonNext-dialogModal', {id: this.id, data: this.dataToSend});
  }

  close() {
    let self = this;
    this.visible = !this.visible;
    if (this.text) this.text.visible = this.visible;
    if (this.graphics) this.graphics.visible = this.visible;
    if (this.image) this.image.visible = this.visible;
    if (this.imageNext) this.imageNext.visible = this.visible;
    if (this.imageCharacterBox) this.imageCharacterBox.visible = this.visible;
    if (this.closeBtn) this.closeBtn.visible = this.visible;
    if (self.timedEvent) self.timedEvent.remove();
    if (self.text) self.text.destroy();
    this.image.destroy();
    this.imageNext.destroy();
    this.imageCharacterBox.destroy();
  }

  setClickEvent(event) {
    this.clickEvent = event;
  }

  // Sets the text for the dialog window
  setText(text, imgToSet, animate1, autoClose = false) {

    if(autoClose) {
      if (this.imageNext) {
        this.imageNext.active = false;
        this.imageNext.visible = false;
      }
    } else {
      if (this.imageNext) {
        this.imageNext.active = true;
        this.imageNext.visible = true;
      }
    }
    // Reset the dialog
    if (imgToSet !== this.imageCharacter) {
      this.imageCharacter = imgToSet;
    }
    if(this.imageCharacterBox) this.imageCharacterBox.destroy();
    this.imageCharacterBox = this.scene.add.sprite(this.dimensions.x + 45, this.dimensions.y + 40, this.imageCharacter, imgToSet === 'note-test' ? 0 : 4).setOrigin(0).setScale(imgToSet === 'note-test' ? 4 : 2).setDepth(1).setScrollFactor(0);

    this.eventCounter = 0;
    this.dialog = text.split('');
    if (this.timedEvent) this.timedEvent.remove();
    let tempText = animate1 ? '' : text;
    this._setText(tempText.toUpperCase());
    if (animate1) {
      this.timedEvent = this.scene.time.addEvent({
        delay: 150 - (this.dialogSpeed * 30),
        callback: () => {
          this.eventCounter++;
          this.text.setText(this.text.text + this.dialog[this.eventCounter - 1]);
          if (this.eventCounter === this.dialog.length) {
            this.timedEvent.remove();
            if(autoClose) {
              setTimeout(() => {
                this.toggleWindow();
              }, 3000);
            }
            // this.scene.events.emit('textShow-dialogModal');
          }
        },
        callbackScope: this,
        loop: true
      });
    } else if(autoClose) {
      setTimeout(() => {
        this.toggleWindow();
      }, 4000);
    }

  }

  _animateText() {
    this.eventCounter++;
    this.text.setText(this.text.text + this.dialog[this.eventCounter - 1]);
    if (this.eventCounter === this.dialog.length) {
      this.timedEvent.remove();
      // if(autoClose) {
      //   self.toggleWindow();
      // }
      // this.scene.events.emit('textShow-dialogModal');
    }
  }
  // Calcuate the position of the text in the dialog window
  _setText(text) {
    // Reset the dialog
    if (this.text) this.text.destroy();

    this.text = this.scene.add.bitmapText(170, 365, 
      'pixelfont', text.toUpperCase(), 10).setTint(0x000000).setDepth(1).setScrollFactor(0);
    // let x = this.padding + 135;
    // let y = this._getGameHeight() - this.windowHeight - this.padding + 37;
    // this.text = this.scene.make.text({
    //   x,
    //   y,
    //   text: text.toUpperCase(),
    //   style: {
    //     fontFamily: 'CustomFont',
    //     fontSize: '18px',
    //     color: '#000000',
    //     resolution: 1
    //   }
    // }).setLineSpacing(3);

    // this.text.setDepth(1).setScrollFactor(0);
  }

  _createImageDialog(scene, id, data = null, idImage = 'dialog-test') {
    this.scene = scene;
    this.dataToSend = data;
    this.id = id;
    let gameHeight = this._getGameHeight();
    let gameWidth = this._getGameWidth();
    this.dimensions = this._calculateWindowDimensions(gameWidth, gameHeight);
    this.image = scene.add.image(this.dimensions.x,this.dimensions.y, idImage).setOrigin(0).setScale(3).setDepth(1).setScrollFactor(0);
    this.visible = true;

    this.imageNext = this.scene.add.image(this.dimensions.x + 685,this.dimensions.y + 50, 'buttonPlayInit').setInteractive({ useHandCursor: true }).setOrigin(0, 1).setScale(1).setDepth(1).setScrollFactor(0);
      this.imageNext.on('pointerdown', () => {

        this.imageNext.setAlpha(0.4)
      }).on('pointerup', () => {
        this.imageNext.setAlpha(1);
        this.toggleWindow();

      });
  }
}